<template>
    <div>
        <v-text-field outlined dense readonly color="success" :label="label" :prepend-icon="prependIcon" v-model="text"
            :hint="hint" persistent-hint :error="error" :error-messages="errorMessages">
            <template v-slot:append>
                <v-icon color="success" @click="abrirModal" :disabled="disabled">
                    mdi-magnify
                </v-icon>
            </template>
        </v-text-field>
        <v-dialog transition="dialog-bottom-transition" v-model="modalPicker" max-width="1200px">
            <validation-observer ref="observer" v-slot="{ }">
                <v-form>
                    <v-card class="elevation-0">
                        <v-toolbar flat outlined>
                            <v-toolbar-title>
                                <v-icon color="success">{{ icon }}</v-icon>
                                {{ title }}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="fecharModal()">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text class="pa-5">
                            <!-- Filtros modernos sem card aninhado -->
                            <div class="filters-section">
                                <v-row cols="12">
                                    <v-col sm="10" md="10">
                                        <soi-input
                                            outlined
                                            dense
                                            color="primary"
                                            v-model="filtro"
                                            :append-icon="filtro ? 'mdi-close' : 'mdi-magnify'"
                                            @click:append="filtro ? filtro = '' : null"
                                            label="Digite algo para começar a pesquisar"
                                            class="modern-search-input">
                                        </soi-input>
                                    </v-col>
                                    <v-col sm="2" md="2">
                                        <soi-select
                                            outlined
                                            dense
                                            color="primary"
                                            :value="itemsPerPage"
                                            @input="itemsPerPage = parseInt($event, 10)"
                                            label="Qtde. Itens"
                                            :items="itemsPerPagination"
                                            class="modern-select">
                                        </soi-select>
                                    </v-col>
                                </v-row>
                            </div>

                            <v-row>
                                <v-col cols="12" md="12" sm="12" :class="{ 'hide-scrollbar': itemsPerPage === 5 }"
                                    style="max-height: 600px; overflow-y: auto;">
                                    <v-data-table
                                        :loading="carregando ? 'success' : null"
                                        :headers="headers"
                                        :items="items"
                                        :items-per-page="itemsPerPage"
                                        :search="filtro"
                                        :ref="tableRef"
                                        :single-select="singleSelect"
                                        :page.sync="page"
                                        hide-default-footer
                                        @page-count="pageCount = $event"
                                        item-key="id"
                                        v-model="selected"
                                        class="modern-picker-table"
                                        no-data-text="Nenhum registro encontrado!"
                                        loading-text="Carregando os itens desta tabela! Aguarde..."
                                        no-results-text="Nenhum item encontrado com os termos pesquisados."
                                        show-select>
                                        <template v-slot:item.actions="{ item }">
                                            <v-btn v-for="(button, index) in actions" :key="index" class="mx-2" x-small
                                                fab :title="button.label" :color="button.color"
                                                @click="handleAction(button.action, item)">
                                                <v-icon>{{ button.icon }}</v-icon>
                                            </v-btn>
                                        </template>
                                    </v-data-table>
                                    <v-pagination
                                        v-model="page"
                                        :length="pageCount"
                                        :total-visible="7"
                                        color="primary"
                                        class="modern-pagination">
                                    </v-pagination>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-row justify="end">
                              <v-btn color="error" @click="fecharModal()" class="mr-2 modern-btn">
                                  <v-icon left>mdi-close</v-icon>
                                  Fechar
                              </v-btn>
                              <v-btn color="primary" @click="select()" :loading="carregando" :disabled="carregando" class="mr-2 modern-btn">
                                  <v-icon left>mdi-plus</v-icon>
                                  Selecionar
                              </v-btn>
                            </v-row>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </validation-observer>
        </v-dialog>
    </div>
</template>

<script lang="ts">
import { MensagemMixin } from '@/helpers/MensagemHelper';
import Vue from 'vue';

export default Vue.component('soi-picker', {
  props: {
    label: {
      type: String,
      required: true,
      default: 'Selecione um item...',
    },
    prependIcon: {
      type: String,
      required: false,
      default: '',
    },
    disabled: {
      type: Boolean,
      required: true,
      default: false,
    },
    value: {},
    rules: {
      type: Object,
      default() {
        return {};
      },
      required: false,
    },
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    headers: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    singleSelect: {
      type: Boolean,
      required: true,
      default: true,
    },
    hint: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    actions: {
      type: Array,
      default: () => [],
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMessages: {
      type: [Array, String],
      default: () => [],
    },
  },
  watch: {
    value() {
      this.$nextTick(async function () {
        this.text = this.value;
        if (this.modalPicker && this.items && this.items.length > 0) {
          if (this.value && typeof this.value === 'string' && this.value.trim() !== '') {
            const itemEncontrado = this.items.find((item: any) => {
              if (!item.nome) return false;

              const nomeCompleto = `${item.nome} (${item.principioAtivo || ''})`;
              const nomeCompletoSemEspacos = nomeCompleto.replace(/\s+/g, ' ').trim();
              const valueSemEspacos = this.value.replace(/\s+/g, ' ').trim();

              return nomeCompletoSemEspacos === valueSemEspacos
                || item.nome.trim() === this.value.trim()
                || nomeCompleto === this.value;
            });

            if (itemEncontrado) {
              this.selected = [itemEncontrado];
            } else {
              this.selected = [];
            }
          } else {
            this.selected = [];
          }
        }
      });
    },
  },
  data() {
    return {
      modalPicker: false,
      filtro: '',
      text: this.value,
      selected: [],
      itemsPerPage: 5,
      carregando: false,
      tableRef: `table-picker-${this.name}`,
      page: 1,
      pageCount: 0,
      itemsPerPagination: [
        { value: 5, text: 5 },
        { value: 10, text: 10 },
        { value: 15, text: 15 },
      ],
    };
  },
  methods: {
    abrirModal() {
      this.filtro = '';
      this.page = 1;
      this.modalPicker = true;
      this.$emit('update');

      this.$nextTick(() => {
        this.selected = [];
        if (this.value && this.items && this.items.length > 0) {
          if (typeof this.value === 'string' && this.value.trim() !== '') {
            const itemEncontrado = this.items.find((item: any) => {
              if (!item.nome) return false;

              const nomeCompleto = `${item.nome} (${item.principioAtivo || ''})`;
              const nomeCompletoSemEspacos = nomeCompleto.replace(/\s+/g, ' ').trim();
              const valueSemEspacos = this.value.replace(/\s+/g, ' ').trim();

              return nomeCompletoSemEspacos === valueSemEspacos
                || item.nome.trim() === this.value.trim()
                || nomeCompleto === this.value;
            });

            if (itemEncontrado) {
              this.selected = [itemEncontrado];
            }
          } else if (Array.isArray(this.value) && this.value.length > 0) {
            this.selected = [...this.value];
          } else if (this.value && typeof this.value === 'object') {
            this.selected = [this.value];
          }
        }
      });
    },
    fecharModal() {
      this.filtro = '';
      this.selected = [];
      this.modalPicker = false;
      this.page = 1;
    },
    select() {
      const selectedItems = this.selected;

      if (selectedItems.length === 0) {
        MensagemMixin(3000, 'error', `É necessário selecionar pelo menos um(a) ${this.label ? this.label : this.title}.`);
      } else {
        this.modalPicker = false;
        this.$emit('change', selectedItems);
      }
    },
    handleAction(action, item) {
      this.$emit(action, item);
    },
  },
});
</script>

<style>
.v-dialog {
  box-shadow: none !important;
}
.especialidade-ortopedia .v-sheet.v-sheet--outlined.theme--light.v-toolbar.v-toolbar--flat,
.especialidade-oftalmologia .v-sheet.v-sheet--outlined.theme--light.v-toolbar.v-toolbar--flat,
.especialidade-neurologia .v-sheet.v-sheet--outlined.theme--light.v-toolbar.v-toolbar--flat,
.especialidade-clinico-geral .v-sheet.v-sheet--outlined.theme--light.v-toolbar.v-toolbar--flat,
.especialidade-pediatria .v-sheet.v-sheet--outlined.theme--light.v-toolbar.v-toolbar--flat,
.especialidade-cardiologia .v-sheet.v-sheet--outlined.theme--light.v-toolbar.v-toolbar--flat,
.especialidade-dermatologia .v-sheet.v-sheet--outlined.theme--light.v-toolbar.v-toolbar--flat,
.especialidade-endocrinologia .v-sheet.v-sheet--outlined.theme--light.v-toolbar.v-toolbar--flat,
.especialidade-angiologia .v-sheet.v-sheet--outlined.theme--light.v-toolbar.v-toolbar--flat,
.especialidade-ginecologia-e-obstetrícia .v-sheet.v-sheet--outlined.theme--light.v-toolbar.v-toolbar--flat,
.especialidade-proctologia .v-sheet.v-sheet--outlined.theme--light.v-toolbar.v-toolbar--flat,
.especialidade-psiquiatria .v-sheet.v-sheet--outlined.theme--light.v-toolbar.v-toolbar--flat,
.especialidade-reumatologia .v-sheet.v-sheet--outlined.theme--light.v-toolbar.v-toolbar--flat,
.especialidade-urologia .v-sheet.v-sheet--outlined.theme--light.v-toolbar.v-toolbar--flat,
.especialidade-padrao .v-sheet.v-sheet--outlined.theme--light.v-toolbar.v-toolbar--flat {
  background-color: var(--especialidade-secondary) !important;
}

/* CORREÇÃO ESPECÍFICA PARA ALINHAMENTO DOS HEADERS NO PICKER */
.v-data-table thead th {
  padding: 10px !important;
  padding-right: 15px !important;
}

.modern-picker-table thead th .v-data-table__checkbox {
  margin-left: 6px;
}

</style>
